var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15312 0.768753C4.9125 0.187503 4.27812 -0.121872 3.67188 0.0437527L0.921875 0.793753C0.378125 0.943753 0 1.4375 0 2C0 9.73125 6.26875 16 14 16C14.5625 16 15.0563 15.6219 15.2063 15.0781L15.9563 12.3281C16.1219 11.7219 15.8125 11.0875 15.2312 10.8469L12.2312 9.59688C11.7219 9.38438 11.1313 9.53125 10.7844 9.95938L9.52188 11.5C7.32188 10.4594 5.54063 8.67813 4.5 6.47813L6.04063 5.21875C6.46875 4.86875 6.61562 4.28125 6.40312 3.77188L5.15312 0.771878V0.768753Z",
    fill: "#0270B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7258bc426278e76bddcdcb557b1c0987.svg";
export { ForwardRef as ReactComponent };